const _excluded = ["animation", "arrow", "children", "className", "closeRequestKey", "content", "placement", "style", "theme", "trigger", "minWidth"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { autoUpdate, safePolygon, useClick, useFloating, useFocus, useHover, useInteractions, useRole } from '@floating-ui/react';
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import { getArrowPlacement, getMiddleware, getPlacement } from '../../helpers/floating';
/**
 * @see https://floating-ui.com/docs/react-dom-interactions
 */
export const Floating = _ref => {
  let _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? 'duration-300' : _ref$animation,
    _ref$arrow = _ref.arrow,
    arrow = _ref$arrow === void 0 ? true : _ref$arrow,
    children = _ref.children,
    className = _ref.className,
    closeRequestKey = _ref.closeRequestKey,
    content = _ref.content,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top' : _ref$placement,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? 'dark' : _ref$style,
    theme = _ref.theme,
    _ref$trigger = _ref.trigger,
    trigger = _ref$trigger === void 0 ? 'hover' : _ref$trigger,
    minWidth = _ref.minWidth,
    props = _objectWithoutProperties(_ref, _excluded);
  const arrowRef = useRef(null);
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  const floatingTooltip = useFloating({
    middleware: getMiddleware({
      arrowRef,
      placement
    }),
    onOpenChange: setOpen,
    open,
    placement: getPlacement({
      placement
    })
  });
  const context = floatingTooltip.context,
    _floatingTooltip$midd = floatingTooltip.middlewareData.arrow,
    _floatingTooltip$midd2 = _floatingTooltip$midd === void 0 ? {} : _floatingTooltip$midd,
    arrowX = _floatingTooltip$midd2.x,
    arrowY = _floatingTooltip$midd2.y,
    refs = floatingTooltip.refs,
    strategy = floatingTooltip.strategy,
    update = floatingTooltip.update,
    x = floatingTooltip.x,
    y = floatingTooltip.y;
  const _useInteractions = useInteractions([useClick(context, {
      enabled: trigger === 'click'
    }), useFocus(context), useHover(context, {
      enabled: trigger === 'hover',
      handleClose: safePolygon()
    }), useRole(context, {
      role: 'tooltip'
    })]),
    getFloatingProps = _useInteractions.getFloatingProps,
    getReferenceProps = _useInteractions.getReferenceProps;
  useEffect(() => {
    if (refs.reference.current && refs.floating.current && open) {
      return autoUpdate(refs.reference.current, refs.floating.current, update);
    }
  }, [open, refs.floating, refs.reference, update]);
  useEffect(() => {
    if (closeRequestKey !== undefined) setOpen(false);
  }, [closeRequestKey]);
  return _jsxs(_Fragment, {
    children: [_jsx("div", _objectSpread(_objectSpread({
      ref: refs.setReference,
      className: theme.target,
      "data-testid": "flowbite-tooltip-target"
    }, getReferenceProps()), {}, {
      children: children
    })), _jsxs("div", _objectSpread(_objectSpread({
      ref: refs.setFloating,
      "data-testid": "flowbite-tooltip"
    }, getFloatingProps(_objectSpread({
      className: classNames(theme.base, animation && `${theme.animation} ${animation}`, !open && theme.hidden, theme.style[style], className),
      style: {
        position: strategy,
        top: y !== null && y !== void 0 ? y : ' ',
        left: x !== null && x !== void 0 ? x : ' ',
        minWidth
      }
    }, props))), {}, {
      children: [_jsx("div", {
        className: theme.content,
        children: content
      }), arrow && _jsx("div", {
        className: classNames(theme.arrow.base, {
          [theme.arrow.style.dark]: style === 'dark',
          [theme.arrow.style.light]: style === 'light',
          [theme.arrow.style.auto]: style === 'auto'
        }),
        "data-testid": "flowbite-tooltip-arrow",
        ref: arrowRef,
        style: {
          top: arrowY !== null && arrowY !== void 0 ? arrowY : ' ',
          left: arrowX !== null && arrowX !== void 0 ? arrowX : ' ',
          right: ' ',
          bottom: ' ',
          [getArrowPlacement({
            placement: floatingTooltip.placement
          })]: theme.arrow.placement
        },
        children: "\u00A0"
      })]
    }))]
  });
};